module.exports = __webpack_public_path__ + "static/media/kuaraAccessBarLogo.f2d8c669.svg";